
<!--
 * @Description: 教职工详情 学习简历
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:39:36
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="学习单位" label-align="right" align="left" width="120px" span="2">{{item.xxdw}}</el-descriptions-item>
      <el-descriptions-item label="学习起始日期" label-align="right" align="left" width="120px" span="2">{{item.xxqsrq}}</el-descriptions-item>
      <el-descriptions-item label="学习终止日期" label-align="right" align="left" width="120px" span="2">{{item.xxzzrq}}</el-descriptions-item>
      <el-descriptions-item label="学习内容" label-align="right" align="left" width="120px" span="2">{{item.xxnr}}</el-descriptions-item>
      <el-descriptions-item label="所学专业名称" label-align="right" align="left" width="120px" span="2">{{item.sxzymc}}</el-descriptions-item>
      <el-descriptions-item label="所获学位" label-align="right" align="left" width="120px" span="2">{{item.shxwbt}}</el-descriptions-item>
      <el-descriptions-item label="学习证明人" label-align="right" align="left" width="120px" span="2">{{item.xxzmr}}</el-descriptions-item>
      <el-descriptions-item label="学习简历备注" label-align="right" align="left" width="120px" span="2">{{item.xxjlbz}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongxuexijianli/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
